import { createRouter, createWebHistory } from 'vue-router'
import MeterAudit from '../views/meter-audit.vue'
import NotFound from '../views/page-not-found.vue'

function removeQueryParams(to) {
  // p2mtqTWsTW
  console.log('removeQueryParams', to)
  if (to.params.key === 'p2mtqTWsTW')
    return true
  else
    return false
}

const routes = [
  {
    path: '/:word_id',
    name: 'Meter Audit',
    component: MeterAudit
  },
  {
    path: '/devcreation/:key',
    component: () => import(/* webpackChunkName: "DevCreation" */ '../views/dev-creation.vue'),
    beforeEnter: [removeQueryParams],
  },
  {
    path: '/',
    name: 'Landing Page',
    component: () => import(/* webpackChunkName: "about" */ '../views/des-landing.vue')
  },
    // plan on directly navigating to the not-found route using its name
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
    // if you omit the last `*`, the `/` character in params will be encoded when resolving or pushing
    { path: '/:pathMatch(.*)', name: 'bad-not-found', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.resolve({
  name: 'not-found',
  params: { pathMatch: ['not', 'found'] },
}).href // '/not/found'

export default router
